import * as React from 'react'

export const ErrorMessage = ({ children }: { children?: string }) => {
  return (
    <p className="tw-text-sm tw-font-medium tw-text-destructive">{children}</p>
  )
}
